import { Flex, Form } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { NOTIFICATION_TYPE_ENUM, RateEntity } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";

import { updateRates } from "services/settingsService";
import { useStores } from "stores";
import { CustomButton, NumberInput } from "ui";
import { parseErrorMessage } from "utils";
import { _greaterOrEqual, _isRate, _isRequired } from "utils/form/simple-validation";

interface IParams {
  rates: RateEntity;
}

export const UpdateRateModal = observer((params: IParams) => {
  const { rates } = params;
  const { actionModals, settings } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const editRateHandler = async () => {
    setLoading(true);

    const formData = {
      rates: Object.assign(
        {},
        ...Object.keys(form.getFieldsValue()).map((key) => ({
          [key as keyof RateEntity]: form.getFieldValue(key),
        }))
      ),
    };

    await updateRates(formData)
      .then(() => {
        openNotification({
          message: "Данные успешно обновлены",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => settings.fetchRates(), 1500);
        handleCancelEditRates();
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelEditRates = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical>
      <Form
        form={form}
        name="editRates"
        initialValues={{
          ...Object.keys(rates.rates).reduce(
            (acc, key) => {
              acc[key] = rates.rates[key];
              return acc;
            },
            {} as Record<string, number>
          ),
        }}
        onFinish={() => editRateHandler()}
      >
        <Flex vertical>
          {Object.keys(rates.rates).map((rate, index) => (
            <Flex vertical key={index}>
              <Form.Item
                name={rate}
                rules={[_isRequired("Поле обязательно для ввода"), _greaterOrEqual(0), _isRate()]}
                validateDebounce={FORM_VALIDATION_DEBOUNCE}
              >
                <NumberInput placeholder={`Курс ${rate}`} disabled={loading} />
              </Form.Item>
            </Flex>
          ))}
        </Flex>
        <Form.Item>
          <Flex gap="large">
            <CustomButton htmlType="submit" disabled={loading} loading={loading} className="full-width">
              Сохранить изменения
            </CustomButton>
            <CustomButton
              className="full-width"
              htmlType="button"
              disabled={loading}
              loading={loading}
              type="default"
              onClick={handleCancelEditRates}
            >
              Отменить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
